<template>
  <section class="auto-complete" >
    <input
      ref="field"
      v-model="search"
      @input="type($event.target.value)"
      @focus="focusInput"
      @focusout="closeDrop($event)"
      :class="css"
      :placeholder="placeholder" type="text"
    />
    <div
      ref="autoList"
      class="auto-list"
      :class="{ show : openDrop }"
      :style="`width: ${$refs.field && $refs.field.clientWidth || 0}px`"
    >
      <div
        ref="autoListItem"
        v-for="(item, i) in filteredList"
        @click="selectItem(item, $event)"
        :key="i"
        class="auto-list-item"
      >
        {{ item }}
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'autocomplete',
  props: ['model', 'selectList', 'list', 'css', 'placeholder', 'doNotSort'],
  data () {
    return {
      openDrop: false,
      search: ''
    }
  },
  computed: {
    filteredList () {
      if (this.doNotSort) {
        return this.list.filter(x => x.toUpperCase().indexOf(this.search.toUpperCase()) > -1)
      }
      return this.list.filter(x => x.toUpperCase().indexOf(this.search.toUpperCase()) > -1).sort()
    }
  },
  mounted () {
    this.search = this.model() || ''
  },
  methods: {
    type (value) {
      this.search = value
      this.model(value)
      this.openDrop = true
    },
    selectItem (value) {
      if (!this.selectList) {
        this.search = value
        this.openDrop = false
        this.model(value)
      } else this.model(value)
    },
    closeDrop (event) {
      if (
        !this.selectList ||
        (event.type !== 'focusout' &&
        !this.$refs.autoListItem.find(x => x === event.target))
      ) {
        setTimeout(() => { this.openDrop = false }, 200)
        document.removeEventListener('mousedown', this.closeDrop)
      }
    },
    focusInput ($event) {
      if (this.selectList) {
        this.$refs.field.isList = true
        document.addEventListener('mousedown', this.closeDrop)
      }

      $event.target.select()
      this.openDrop = true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../_asset/scss/_variables";

.auto-complete {
  input {
    width: 100%;
    box-sizing: border-box;
    text-transform: capitalize;
  }

  &.error {
    input {
      border: 1px solid $error-color;
      background-color: rgba(136, 0, 0, 0.1);
    }
  }

  .auto-list {
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 1px 1px 5px -1px rgba(0,0,0,0.2);
    position: absolute;
    overflow-x: hidden;
    max-height: 0;
    visibility: hidden;
    transition: max-height 0.8s;
    z-index: 9;
    &.show {
      max-height: 250px;
      overflow-x: scroll;
      visibility: visible;
    }
  }

  .auto-list-item {
    padding: 8px 10px;
    font-size: 1em;
    border-bottom: 1px dashed #ddd;
    cursor: pointer;
    &:hover {
      background-color: rgba(86, 0, 112, 0.1);
    }
  }
}
</style>
